import { useSyncValidation, timeValidation } from '@gem/modules/validations';

import type { IFormFieldValidation, ValidationResult } from '../hooks';

export interface IDateTimeValidations {
  time: IFormFieldValidation;
}

export const useSharedDateTimeValidations = (): IDateTimeValidations => {
  const timeValidator = useSyncValidation();

  return {
    time: {
      validate: (value, _formData, meta, data): ValidationResult => {
        return timeValidator({
          value,
          meta: meta!,
          data,
          validate: timeValidation,
        });
      },
    },
  };
};
